import { GrantsType, hasScopedPermission } from '../../../Shared/utils/auth';

export const addDriverPermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.add');

export const removeDriverPermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.remove');

export const editDriverPermissionsPolicy = (grants: GrantsType) =>
  editDriverDetailsPermissionsPolicy(grants) ||
  editDriverLicensePermissionsPolicy(grants) ||
  editDriverReportPermissionsPolicy(grants);

export const editDriverDetailsPermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.edit_details');

export const editDriverLicensePermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.edit_driver_license');

export const editDriverReportPermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.edit_report_details');

export const excludeDriverPermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.exclude');

export const editDriverStatusPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'drivers.edit_driver_status');
